import api, { initializeApi } from "api/api";
import { API_ENDPOINTS } from "constants/api";
import {
  clearTokens,
  getAccessToken,
  getAuthErrorMessage,
  normalizeAccountUser,
  parseAuthCallbackParams,
  setTokens,
} from "domain/account";

export const fetchAuthenticatedUser = async () => {
  const response = await api.get(API_ENDPOINTS.USER.ME);
  return normalizeAccountUser(response.data);
};

export const exchangeOpenIdCallback = async (openidParams) => {
  const response = await api.post(
    API_ENDPOINTS.AUTH.TOKEN_OBTAIN,
    openidParams,
  );
  setTokens(response.data.access, response.data.refresh);
  return response.data;
};

export const initializeAuthSession = async ({
  locationSearch,
  loadUser,
  onAuthenticated,
  onAnonymous,
}) => {
  await initializeApi();

  const { openidParams, nextPath, hasOpenIdCallback } =
    parseAuthCallbackParams(locationSearch);

  if (hasOpenIdCallback) {
    await exchangeOpenIdCallback(openidParams);
    const user = await loadUser();
    onAuthenticated?.({ user, nextPath });
    return { kind: "openid-callback", user, nextPath };
  }

  if (getAccessToken()) {
    const user = await loadUser();
    onAuthenticated?.({ user, nextPath: null });
    return { kind: "existing-session", user, nextPath: null };
  }

  onAnonymous?.();
  return { kind: "anonymous", user: null, nextPath: null };
};

export const resolveAuthError = (error, fallbackMessage) =>
  getAuthErrorMessage(error, fallbackMessage);

export const resetAuthSession = () => {
  clearTokens();
};
